import { EnrollmentPropositionLight } from '../../lib/types/models/enrollment/enrollment-light'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getMainProposition(enrollmentId: number) {
  return restApiClient
    .url(
      encodeNestedObject(
        constructApiUrl(API.enrollments.getMainProposition.url, { id: enrollmentId }),
        { version: 'LIGHT' }
      )
    )
    .get<EnrollmentPropositionLight>()
}
